export default function getResource(label, vars=[]) {
    const resources = {
        new: 'Nouveauté',
        value: 'valeur',
        colors: 'Couleurs',
        color: 'Couleur',
        quickLook: 'Aperçu rapide',
        sponsored: 'Commandité',
        regPrice: ' Prix courant',
        selectSaleItems: 'Sélectionner les articles en solde',
        viewSimilarProducts: 'Voir des produits similaires',
        purchased: 'ACHETÉS',
        bestseller: 'BESTSELLER',
        buyItAgain: 'ACHETER DE NOUVEAU',
        percentageOff: `${vars[0]} % DE RÉDUCTION`,
        percentageOffRange: `JUSQU’À ${vars[0]} DE RÉDUCTION`
    };

    return resources[label];
}
